import { useEffect } from 'react'
import { logger } from '@/lib/logger'

export function useWakeLock(): void {
  useEffect(() => {
    if (!('wakeLock' in navigator)) return

    let sentinel: WakeLockSentinel | null = null

    async function acquire() {
      try {
        sentinel = await navigator.wakeLock.request('screen')
      } catch (err) {
        logger.warn('Wake lock could not be acquired', { error: String(err) })
      }
    }

    acquire()

    // Re-acquire wake lock when page becomes visible again (browser releases it on hide)
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        acquire()
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      sentinel?.release().catch((err) => {
        logger.warn('Wake lock release failed', { error: String(err) })
      })
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])
}
